/** Bundle Cart Products */

/* Fetch API Adds */
(function (ns, fetch) {
  if (typeof fetch !== "function") return;

  ns.fetch = function () {
    const response = fetch.apply(this, arguments);

    response.then((res) => {
      if (
        [
          `${window.location.origin}/cart/add.js`,
          `${window.location.origin}/cart/update.js`,
          `${window.location.origin}/cart/change.js`,
          `${window.location.origin}/cart/clear.js`,
        ].includes(res.url)
      ) {
        res
          .clone()
          .json()
          .then((data) => {
            bundleProducts();
          });
      }
    });

    return response;
  };
})(window, window.fetch);

/* AJAX API ADDS */
const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      bundleProducts();
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function bundleProducts() {
  $.getJSON("/cart.js", function (cart) {
    var items = cart.items;
    var product_one,
      product_two,
      product_three = false;
    var routine_qty = 1;
    var routine_key = 32205390676065;

    for (var i = 0; i < items.length; i++) {
      if (items[i].product_id == 4611984326753) {
        product_one = true;
        var product_one_qty = items[i].quantity - 1;
      }
      if (items[i].product_id == 4611987210337) {
        product_two = true;
        var product_two_qty = items[i].quantity - 1;
      }
      if (items[i].product_id == 4611987636321) {
        product_three = true;
        var product_three_qty = items[i].quantity - 1;
      }
      if (items[i].variant_id == routine_key) {
        routine_qty = items[i].quantity + 1;
      }
    }

    if (product_one == true && product_two == true && product_three == true) {
      var params = {
        type: "POST",
        url: "/cart/update.js",
        data:
          "&updates[" +
          routine_key +
          "]=" +
          routine_qty +
          "&updates[32205381501025]=" +
          product_one_qty +
          "&updates[32205389365345]=" +
          product_two_qty +
          "&updates[32205390119009]=" +
          product_three_qty +
          "",
        dataType: "json",
        success: function () {
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: routine_key,
                quantity: routine_qty,
              },
            })
          );
          setTimeout(function () {
            $("#routine-track-in-klaviyo").click();
          }, 3000);
        },
        error: function (XMLHttpRequest, textStatus) {},
      };
      jQuery.ajax(params);
    }
  });
}

window.openSubsList = function (target) {
  $closesetDiv = target.closest(".to-subs");
  $($closesetDiv).find(".to-subs__list").slideToggle(300);
};
window.selectSubsItem = function (target) {
  $closesetDiv = target.closest(".to-subs");
  $($closesetDiv).find(".to-subs__item").removeClass("selected");
  target.classList.add("selected");
};
window.applySubs = function (target) {
  $closesetDiv = target.closest(".to-subs");
  $dataId = $($closesetDiv).find(".to-subs__item.selected").data("id");

  $parrentItem = target.closest(".JsSubsParent");
  $variantId = $($parrentItem).find(".JsSubsItem").data("id");

  $quantity = $($parrentItem).find(".QuantitySelector__CurrentQuantity").val();
  const key = $($parrentItem).find(".JsSubsItem").data("key");
  $($closesetDiv).find(".to-subs__list").slideUp(300);

  let data = {
    id: $variantId,
    quantity: $quantity,
    selling_plan: $dataId,
    utf8: "✓",
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      if (key) {
        $.post("/cart/update.js", {
          updates: {
            [key]: 0,
          },
        }).then(function () {
          customCartDrawer();
        });
        return;
      }
      customCartDrawer("collection");
    },
  });
};

window.upsellAddToCart = function (target) {
  let id = target.dataset.id;

  let data = {
    id: id,
    quantity: 1,
    utf8: "✓",
  };

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: data,
    dataType: "json",
    success: function () {
      customCartDrawer();
    },
  });
};

window.addFree = async function (cart) {
  let cartIds = [];
  cart.items.forEach(function (item) {
    cartIds.push(item.id);
  });
  console.log("ids", cartIds);
  if (cart.total_price >= 7500 && cartIds.indexOf(40625120510049) === -1) {
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        items: [
          {
            id: 40625120510049,
            quantity: 1,
          },
        ],
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        return response;
      });
  }
};

function customCartDrawer(payload) {
  let path = "drawer";
  if (window.location.href.split("/").pop() == "cart") {
    path = "ajax";
  }
  fetch(`/cart?view=` + path, {
    credentials: "same-origin",
    method: "GET",
  }).then(function (content) {
    content.text().then(function (html) {
      var tempElement = document.createElement("div");
      tempElement.innerHTML = html;
      var cartNodeParent = document.querySelector(".Cart").parentNode;
      cartNodeParent.replaceChild(
        tempElement.querySelector(".Cart"),
        document.querySelector(".Cart")
      );
      // LSG Trigger Upsell Carousel
      let lsgCartSlides = document.querySelectorAll(
        "[lsg-cart-slider]:not(.flickity-enabled)"
      );
      lsgCartSlides.forEach((slide) => {
        $(slide).flickity({
          freeScroll: false,
          wrapAround: true,
          groupCells: false,
          autoPlay: false,
          adaptiveHeight: false,
          cellAlign: "center",
          prevNextButtons: true,
          pageDots: false,
        });
      });
    });
    if (payload) {
      $(
        '.header-cart__item[data-action="open-drawer"] .Header__CartDot'
      ).click();
    }
  });
}
setTimeout(function () {
  $(".template-product.product--4611987964001")
    .find(".Product__InfoWrapper .ProductMeta__Description")
    .hide();
}, 200);

$(".template--redesign-2 .Product__SlideshowNavScroller").flickity({
  pageDots: false,
  percentPosition: false,
  groupCells: "100%",
  draggable: true,
  contain: true,
});
function recTitleHeight() {
  let maxHeight = 0;
  $('[data-section-type="product-recommendations"] .ProductItem__Title').each(
    function () {
      let h = $(this).outerHeight();
      if (h > maxHeight) {
        maxHeight = h;
      }
    }
  );
  // $('[data-section-type="product-recommendations"] .flickity-viewport').css('height', `${maxHeight}px`)
  $('[data-section-type="product-recommendations"] .ProductItem__Title').css(
    "height",
    `${maxHeight}px`
  );
  $('[data-section-type="product-recommendations"]').each(function () {
    let height = $(this).find(".Carousel__Cell").outerHeight();
    $(this).find(".flickity-viewport").css("height", `${height}px`);
  });
}
$(window).resize(() => {
  $('[data-section-type="product-recommendations"] .ProductItem__Title').css(
    "height",
    "auto"
  );
  recTitleHeight();
});
setTimeout(() => {
  recTitleHeight();
}, 1200);

$(document).on(
  "click",
  ".template--redesign-2 .Product__SlideshowNavImage",
  function (e) {
    e.preventDefault();
    $(".Product__SlideshowNavImage").removeClass("active");
    $(e.target).closest(".Product__SlideshowNavImage").addClass("active");
  }
);

$(".yotpo-wrap, .p-reviews__link").click(function (e) {
  e.preventDefault();
  let pos = $(".reviews-title").offset().top - 100;
  $("html, body").animate({ scrollTop: pos }, 1000);
});

$(".Product__Tabs .collapsible-button__wrap").click(function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  e.preventDefault();
  let btn = $(this).closest(".Collapsible__Button");
  let opened = $(btn).attr("aria-expanded");
  if (opened === "true") {
    $(btn).attr("aria-expanded", "false");
  } else {
    $(btn).attr("aria-expanded", "true");
  }
  $(btn).siblings(".Collapsible__Inner").slideToggle();
});

$(".pr-meta__show").click(function () {
  $(this).closest(".pr-meta__subtitle").hide();
  $(".pr-meta__subtitle--all").show();
});

$(document).ready(function () {
  const prdShortDescrWrapper = $(".pr-meta__subtitle--part");
  const prdShortDescr = $(".pr-meta__subtitle--part .pr-meta__text");

  if (prdShortDescr) {
    const prdShortDescrText = prdShortDescr.text();

    if (prdShortDescrText.includes("SLICE")) {
      const prdShortDescrTextSliced = prdShortDescrText.substring(
        0,
        prdShortDescrText.indexOf("SLICE")
      );

      prdShortDescr.text(prdShortDescrTextSliced);
    }
  }

  prdShortDescrWrapper.removeClass("hidden");
});

let storedATCEvent;
function fireProductAddedEvent() {
  document.dispatchEvent(
    new CustomEvent("product:added", {
      bubbles: true,
      detail: {
        variant: storedATCEvent.detail.variant,
        quantity: storedATCEvent.detail.quantity,
      },
    })
  );
}
document.addEventListener("product:added:intercept", (e) => {
  storedATCEvent = e;
  fireProductAddedEvent();
});

$(document).on("click", "[data-quick-add]", (e) => {
  let target = $(e.target).closest("[data-quick-add]");
  let variantId = $(target).attr("data-quick-add");
  let quantity = 1;

  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    dataType: "json",
    data: { id: variantId, quantity: quantity },
    success: function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: variantId,
            quantity: 1,
          },
        })
      );
    },
  });
});
